import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import Navbar from "scenes/navbar";
import Sidebar from "../../components/Sidebar";
import SnackbarComponent from "components/SnackbarComponent";

function Layout() {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");
  const [isSideBarOpen, setIsSideBarOpen] = useState(
    isLargeScreen ? true : false
  );

  return (
    <Box display={isLargeScreen ? "flex" : "block"} width="100%" height="100%">
      <Sidebar
        isLargeScreen={isLargeScreen}
        drawerWidth="250px"
        isSideBarOpen={isSideBarOpen}
        setIsSideBarOpen={setIsSideBarOpen}
      />
      <Box flexGrow={1}>
        <Navbar
          isSideBarOpen={isSideBarOpen}
          setIsSideBarOpen={setIsSideBarOpen}
        />
        <Outlet />
      </Box>
      <SnackbarComponent />
    </Box>
  );
}

export default Layout;
